import {
  WidgetBookingType,
  WidgetThemeSettings,
} from "../domain_objects/CrossSellSetupResponse";

export const themeSettings: WidgetThemeSettings = {
  ChannelCode: "ONLINE",
  CustomSuccessPageUrl: "",
  FixedPromotionId: null,
  SkipPromotionsScreen: false,
  DivideTimeSlotsByService: false,
  IsChildrenCoversShown: false,
  IsInfantsCoversShown: false,
  AllowAreaChoice: false,
  IncludeAnyArea: false,
  ShowCustomerTitle: false,
  ShowTelephoneNumberField: false,
  ShowCompanyField: false,
  ShowPostcodeField: false,
  PostcodeRequired: false,
  ShowHouseholdsField: false,
  ShowDateOfBirth: false,
  ShowDateOfBirthYear: false,
  DateOfBirthRequired: false,
  DateOfBirthDescription: "",
  ShowSmsMarketingOption: false,
  ShowOptinCheckboxes: true,
  ShowMobileNumberField: true,
  ShowMembershipIdField: false,
  MembershipIdTitle: "",
  IsMembershipIdRequired: false,
  ShowRoomNumberField: null,
  WidgetBookingType: WidgetBookingType.Booking,
  MarketingLevel: null,
  ContactDetailsTitle: "",
  PrecheckVenueEmailOptin: false,
  ShowCommentsField: false,
};
